
import { Component, Vue, Prop } from 'vue-property-decorator'
// @ts-ignore
import {
  CarouselNextLabel,
  CarouselPrevLabel,
  carouselOption,
} from '@/plugins/globalStaticDatas'

@Component({})
export default class SearchCarousel extends Vue {
  @Prop() productData!: any
  carouselOption: Object = carouselOption
  nextLabel: any = CarouselNextLabel()
  prevLabel: any = CarouselPrevLabel()

  productName(productName: string) {
    if (productName === null) return 'Nuk Ka Emër'
    if (productName.split('').length > 50) {
      return `${productName.split(' ').slice(0, 8).join(' ')}...`
    }
    return productName
  }
}
